import React from "react";

interface NewsPrCardHeroSkeletonProps {
  className?: string;
}

const NewsPrCardHeroSkeleton: React.FC<NewsPrCardHeroSkeletonProps> = ({ className = "" }) => {
  return (
    <div className={`w-full overflow-hidden animate-pulse ${className}`}>
      {/* Top Image Skeleton */}
      <div className="relative w-full lg:h-[593px] h-80 overflow-hidden bg-gray-200 rounded-t-lg">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse"></div>
      </div>

      {/* Content Card Skeleton */}
      <div className="py-9 px-6">
        {/* Date & Category Skeleton */}
        <div className="flex justify-between items-center">
          <div className="h-5 bg-gray-200 rounded w-20 animate-pulse"></div>
          <div className="h-5 bg-gray-200 rounded w-24 animate-pulse"></div>
        </div>

        {/* Title Skeleton */}
        <div className="space-y-3 my-4">
          <div className="h-7 bg-gray-200 rounded w-full animate-pulse"></div>
          <div className="h-7 bg-gray-200 rounded w-4/5 animate-pulse"></div>
          <div className="h-7 bg-gray-200 rounded w-3/5 animate-pulse"></div>
        </div>

        {/* Excerpt Skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-100 rounded w-full animate-pulse"></div>
          <div className="h-4 bg-gray-100 rounded w-5/6 animate-pulse"></div>
          <div className="h-4 bg-gray-100 rounded w-4/6 animate-pulse"></div>
          <div className="h-4 bg-gray-100 rounded w-3/4 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default NewsPrCardHeroSkeleton;




